import React from 'react';
import cx from 'classnames';
import { Profile } from '~/types/models';

interface SearchResultRowProps {
  selected: boolean;
  contact: Profile;
  onContactSelected: (contact: Profile) => void;
}

export default function SearchResultRow({
  contact,
  selected,
  onContactSelected,
}: SearchResultRowProps) {
  return (
    <div
      className={cx(
        [
          'h-[30px] flex flex-row px-4 items-center cursor-pointer',
          'hover:v2-bg-yellow-100 select-none gap-x-2',
        ],
        {
          'v2-bg-yellow-100': selected,
        }
      )}
      onClick={() => {
        onContactSelected(contact);
      }}
    >
      <input type='radio' className='hidden' checked={selected} />
      <img src={contact.image} className='w-5 h-5 rounded-full'></img>
      <div className='flex flex-row gap-x-1 font-circular text-base v2-text-neutral-900'>
        <span className='truncate'>{contact.name}</span>
        <span className='truncate'>{`<${contact.email}>`}</span>
      </div>
    </div>
  );
}
